import { useEffect, useState } from 'react';
import { isExtensionInstalled } from './extensionBridge';

/** Whether the LingoPing extension answers: null while that is still being checked. */
export function useExtensionInstalled(): boolean | null {
  const [installed, setInstalled] = useState<boolean | null>(null);
  useEffect(() => {
    let current = true;
    void isExtensionInstalled().then((found) => {
      if (current) setInstalled(found);
    });
    return () => {
      current = false;
    };
  }, []);
  return installed;
}
